import { useState } from 'react'
import {decodetoken } from './cipher.js'
import Main from './component/main.js'
import Healthmonitoring from './component/healthmonitoring.js'
import '@aws-amplify/ui-react/styles.css'
import { Amplify, Auth } from 'aws-amplify';
import aws_exports from './aws-exports';
import { I18n } from "aws-amplify";
import { translations } from '@aws-amplify/ui';
import './App.css'

Amplify.configure(aws_exports);
I18n.putVocabularies(translations);
I18n.setLanguage('ja');

function App({ signOut, user }) {
  const [code, setcode] = useState("");
  const [date, setdate] = useState("");
  const [name, setname] = useState("");
  
  async function signin(loginid, password) {
    try {
      const user = await Auth.currentSession()
      var id = user.getIdToken()["payload"]["cognito:username"]
      if (id != loginid) {
        Auth.signOut().then(function (value) {
          throw 'id mismatch';
        });
      }
    } catch (err) {
      Auth.signIn(loginid, password).then(function (value) {
        window.location.reload();
      })
    }
  }

  async function tokensignin(token) {
    var value = JSON.parse(await decodetoken(token));
    if ( new Date(value[3]).getTime()+60*60*24*1000*180 > Date.now() ) {//開発コード180日に設定
      signin(value[0], value[1]);
      setcode(value[2]);
      setdate(value[3]);
      setname(value[4]);
    }
  }

  async function logoutifnecessary() {
    try {
      const user = await Auth.currentSession()
      var id = user.getIdToken()["payload"]["cognito:username"]
      if (id == "healthmonitor") {
        await Auth.signOut();
      }
    } catch(err) {}
  }

  let url = new URL(window.location.href);
  let params = url.searchParams;
  var token = params.get('token');
  if(token!=null) {
    tokensignin(token);
  } else {
    logoutifnecessary();
  }
  return (
    <>
      { code==="" ? <Main /> : <><h2>{name}</h2><Healthmonitoring point={{sensors:{earthquake:[{id:code}]}}} datetime={date}/></>}
    </>
  )
}

export default App;
